import { Link } from 'gatsby';

import Icon from 'molecules/Icon';

export interface PostDetailProps {
  icon: string;
  label: string;
  value: string | undefined;
  link?: string;
  className: string;
}

const PostDetail = ({ icon, label, value, link, className = '' }: PostDetailProps) => (
  <div key={value} className={`flex md:gap-3 ${className}`}>
    <div>
      <Icon size={32} icon={icon} className="hidden fill-primary-600 md:block" />
    </div>
    <p className="flex w-full flex-col">
      <span className="text-center text-md text-gray-700 md:text-left">{label}</span>
      <span className="text-center text-md font-bold text-gray-900 md:text-left">
        {link && (
          <Link className="hover:underline" to={link}>
            {value}
          </Link>
        )}
        {!link && value}
      </span>
    </p>
  </div>
);

export default PostDetail;
